// extracted by mini-css-extract-plugin
export default {"header":"style_header__iPSxm","ticketsList":"style_ticketsList__OeRjn","filtersContainer":"style_filtersContainer__nAfhs"};